import { useState } from "react";
import Button from "../../../components/Button";
import { useXmlPreview, usePointsOfSalePreview } from "../hooks";
import { ShowToast } from "../../../components/toast";

type XmlTab = "hotelList" | "pointsOfSale";

export function XmlPreview({ configId }: { configId: string }) {
  const [activeTab, setActiveTab] = useState<XmlTab>("hotelList");
  const xmlPreview = useXmlPreview(configId);
  const posPreview = usePointsOfSalePreview(configId);

  const activeQuery = activeTab === "hotelList" ? xmlPreview : posPreview;
  const xmlContent =
    typeof activeQuery.data === "string"
      ? activeQuery.data
      : activeQuery.data?.xml || activeQuery.data?.content || "";

  const handleCopy = async () => {
    if (!xmlContent) return;
    try {
      await navigator.clipboard.writeText(xmlContent);
      ShowToast({ type: "success", message: "Copied to clipboard" });
    } catch {
      ShowToast({ type: "error", message: "Failed to copy to clipboard" });
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-[#E9E9EB] p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-semibold text-gray-900">XML Preview</h3>
        <div className="flex items-center gap-2">
          <div className="flex bg-gray-100 rounded-md p-0.5">
            <button
              onClick={() => setActiveTab("hotelList")}
              className={`px-3 py-1 text-xs font-medium rounded ${
                activeTab === "hotelList"
                  ? "bg-white shadow-sm"
                  : "text-gray-500"
              }`}
            >
              Hotel List XML
            </button>
            <button
              onClick={() => setActiveTab("pointsOfSale")}
              className={`px-3 py-1 text-xs font-medium rounded ${
                activeTab === "pointsOfSale"
                  ? "bg-white shadow-sm"
                  : "text-gray-500"
              }`}
            >
              Points of Sale XML
            </button>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2 mb-3">
        <Button
          variant="outline"
          size="sm"
          onClick={() => activeQuery.refetch()}
          loading={activeQuery.isFetching}
          disabled={activeQuery.isFetching}
        >
          Load Preview
        </Button>
        {xmlContent && (
          <Button variant="outline" size="sm" onClick={handleCopy}>
            Copy
          </Button>
        )}
      </div>

      {xmlContent ? (
        <pre className="bg-gray-50 p-4 rounded-lg overflow-auto max-h-[400px] text-xs font-mono">
          {xmlContent}
        </pre>
      ) : (
        <p className="text-sm text-gray-400">
          Click "Load Preview" to fetch the XML.
        </p>
      )}
    </div>
  );
}
